import AuthRecoveryDialog from '@/components/login/AuthRecoveryDialog.vue';
export default {
  __name: 'App',
  setup(__props) {
    return {
      __sfc: true,
      AuthRecoveryDialog
    };
  }
};